import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/helpers/treeSort.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.some.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { sortByString } from '@gmini/utils';
export function treeSort(_ref) {
  var data = _ref.data,
      itemKey = _ref.itemKey,
      priorityItemKeyValues = _ref.priorityItemKeyValues;
  var result = [];
  var sortedData = sortByString(_toConsumableArray(data), function (element) {
    return element.title || element.name || '';
  });

  var getSortedChildren = function getSortedChildren(item) {
    var _item$children;

    return (_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length ? treeSort({
      data: sortByString(_toConsumableArray(item.children), function (element) {
        return element.title || element.name || '';
      }),
      itemKey: itemKey,
      priorityItemKeyValues: priorityItemKeyValues
    }) : [];
  };

  var getElementWithSortedChildren = function getElementWithSortedChildren(item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      children: getSortedChildren(item)
    });
  };

  var _loop = function _loop(index) {
    var element = sortedData[index];

    if (priorityItemKeyValues !== null && priorityItemKeyValues !== void 0 && priorityItemKeyValues.some(function (item) {
      return item === element[itemKey];
    })) {
      result.push(getElementWithSortedChildren(element));
    }
  };

  for (var index = 0; index < sortedData.length; index++) {
    _loop(index);
  }

  var _loop2 = function _loop2(_index) {
    var element = sortedData[_index];

    if (!(priorityItemKeyValues !== null && priorityItemKeyValues !== void 0 && priorityItemKeyValues.some(function (item) {
      return item === element[itemKey];
    }))) {
      result.push(getElementWithSortedChildren(element));
    }
  };

  for (var _index = 0; _index < sortedData.length; _index++) {
    _loop2(_index);
  }

  return result;
}